function toDate(dateToCheck) {
  let timestamp = Date.parse(dateToCheck);

  return isNaN(timestamp) ? null : new Date(timestamp);
}

/**
 * Get reset given date's time to 00:00
 */
export function resetTime(date) {
  date.setHours(0, 0, 0, 0);
  return date;
}

/**
 * Get today's date with time reset to 00:00
 */
export function todayNoTime() {
  return resetTime(new Date());
}

/**
 * Get date with offset in days of today with time reset to 00:00
 */
export function todayWithOffsetNoTime(dayOffset) {
  let date = todayNoTime();
  date.setDate(date.getDate() + dayOffset);
  return date;
}

/**
 * Add an amount of days to date.
 */
export function addDays(date, days) {
  return date.setDate(date.getDate() + days);
}

/**
 * Checks if given date is after today at 00:00.
 */
export function todayOrAfter(dateValueToCheck) {
  let dateToCheck = toDate(dateValueToCheck);
  return !!dateToCheck && dateToCheck >= todayNoTime();
}

/**
 * Checks if given date is before tomorrow.
 */
export function todayOrBefore(dateValueToCheck) {
  let dateToCheck = toDate(dateValueToCheck);
  return !!dateToCheck && resetTime(dateToCheck) <= todayNoTime();
}

/**
 * Checks if given date is after offset in days at 00:00.
 */
export function offsetDayOrAfter(dayOffset) {
  return (dateValueToCheck) => {
    let dateToCheck = toDate(dateValueToCheck);
    return !!dateToCheck && dateToCheck >= todayWithOffsetNoTime(dayOffset);
  }
}

/**
 * Checks if given date is a sane date.
 */
export function isSaneYear(dateValueToCheck) {
  let dateToCheck = toDate(dateValueToCheck);
  return !!dateToCheck
      && dateToCheck.getFullYear() > 1970
      && dateToCheck.getFullYear() < 2099;
}
